import { URL } from './Url';




// import { UserContextInstance } from "../instances/Instances";

// const currentUser: UserContextInstance = JSON.parse(sessionStorage.getItem('CurrentUser')!);


const getServicesByOrgId = async (orgId: number) => {
    const response = await fetch(
        `${URL}/Service/getServicesByOrgId?orgId=${orgId}`, {
        method: "Get",
        headers: {
            "Content-Type": "application/json",
        }
    }
    );
    const data = await response.json();
    // console.log(data);
    return data;
}

const getServiceById = async (id: number) => {
  const response =  await fetch(
        `${URL}/Service/getServiceById?serviceid=${id}`, {
        method: "Get",
        headers: {
            'Content-Type': "application/json",

        },
    });
    const data = await response.json();
    return data;
}

const deleteServiceByServiceId = async (serviceId: number) => {
    await fetch(
        `${URL}/Service/deleteServiceById?serviceid=${serviceId}`, {
        method: "Get",
        headers: {
            "Content-Type": "application/json",
        }
    }
    );

}

// const saveServiceByServiceId = async (serviceId: number, title: string, description: string, iconId: number) => {
//     await fetch(
//         `${URL}/Service/saveServiceById?serviceid=${serviceId}`, {
//         method: "Post",
//         headers: {
//             "Content-Type": "application/json",
            

//         },
//         body: JSON.stringify({
//             serviceId: serviceId,
//             title: title,
//             description: description,
//             iconId: iconId,
//         })
//     }
//     );
// };



export { getServicesByOrgId, deleteServiceByServiceId, getServiceById }